/**
 * SN-8293 — the Team Finder Position filter: the chosen sport's own positions,
 * multi-select. Nothing selected means All Positions.
 */

export interface SportPosition {
  /** The player type id, as a string (the select's value type). */
  value: string
  label: string
}

export interface PositionOption {
  label: string
  value: string
}

/** The sport's positions, in the sport's order. */
export const positionFilterOptions = (
  positions: readonly SportPosition[]
): PositionOption[] => positions.map(({ label, value }) => ({ label, value }))

/**
 * A multi-select change → the position ids it stands for, each once, in the
 * sport's order.
 */
export const positionIdsFromSelection = (
  selected: readonly string[],
  positions: readonly SportPosition[]
): string[] => {
  const wanted = new Set(selected)

  const ordered = positions
    .map((position) => position.value)
    .filter((value) => wanted.has(value))
  // An id the sport no longer lists (a stale shared link) is kept, not dropped.
  const unknown = [...wanted].filter(
    (value) => !positions.some((position) => position.value === value)
  )

  return [...ordered, ...unknown]
}
